import ArrowDown from './ArrowDown';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import ArrowRotateLeft from './ArrowRotateLeft';
import ArrowRotateRight from './ArrowRotateRight';
import ArrowUp from './ArrowUp';
import AudioLibrary from './AudioLibrary';
import Back10Secs from './Back10Secs';
import Band from './Band';
import BandMore from './BandMore';
import Bell from './Bell';
import Bluesky from './Bluesky';
import Bookmark from './Bookmark';
import Bracket from './Bracket';
import CastClosedCaption from './CastClosedCaption';
import CastPauseSolid from './CastPauseSolid';
import CastXMarkSolid from './CastXMarkSolid';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import ChevronUp from './ChevronUp';
import Circle from './Circle';
import CircleCheck from './CircleCheck';
import CircleExclamation from './CircleExclamation';
import CircleMinus from './CircleMinus';
import CirclePlay from './CirclePlay';
import CirclePlus from './CirclePlus';
import CircleQuestion from './CircleQuestion';
import CircleStar from './CircleStar';
import CircleXmark from './CircleXmark';
import ClapperboardPlay from './ClapperboardPlay';
import ClockRotateLeft from './ClockRotateLeft';
import DeleteLeft from './DeleteLeft';
import DownLeftAndUpRightToCenter from './DownLeftAndUpRightToCenter';
import Envelope from './Envelope';
import Expand from './Expand';
import FaceFrown from './FaceFrown';
import FaceGrinWide from './FaceGrinWide';
import FaceSmile from './FaceSmile';
import Facebook from './Facebook';
import Foward10Secs from './Foward10Secs';
import Gear from './Gear';
import Ghost from './Ghost';
import HexagonalExclamation from './HexagonalExclamation';
import HouseWindow from './HouseWindow';
import Instagram from './Instagram';
import Lock from './Lock';
import MagnifyinGlass from './MagnifyingGlass';
import Minus from './Minus';
import Notify from './Notify';
import Number01 from './Number01';
import Number02 from './Number02';
import Number03 from './Number03';
import Number04 from './Number04';
import Number05 from './Number05';
import Number06 from './Number06';
import Number07 from './Number07';
import Number08 from './Number08';
import Number09 from './Number09';
import Number10 from './Number10';
import Play from './Play';
import PlayerLibrary from './PlayerLibrary';
import Plus from './Plus';
import Popcorn from './Popcorn';
import Radio from './Radio';
import Screencast from './Screencast';
import ShareNodes from './ShareNodes';
import SolidBackwardStep from './SolidBackwardStep';
import SolidBookmark from './SolidBookmark';
import SolidCheck from './SolidCheck';
import SolidCircle from './SolidCircle';
import SolidFowardStep from './SolidFowardStep';
import SolidPause from './SolidPause';
import SolidPauseCircular from './SolidPauseCircular';
import SolidPlay from './SolidPlay';
import SolidPlayCircular from './SolidPlayCircular';
import SolidUser from './SolidUser';
import SquareCheck from './SquareCheck';
import SquareEllipsis from './SquareEllipsis';
import SquareMinus from './SquareMinus';
import SquareMusic from './SquareMusic';
import SquarePlus from './SquarePlus';
import SquareXmark from './SquareXmark';
import Streaming from './Streaming';
import Subtitles from './Subtitles';
import Tiktok from './Tiktok';
import Trash from './Trash';
import TriangleExclamation from './TriangleExclamation';
import TurnBack from './TurnBack';
import Tv from './Tv';
import Twitter from './Twitter';
import TwoSliders from './TwoSliders';
import UpRightAndDownLeftFromCenter from './UpRightAndDownLeftFromCenter';
import Video from './Video';
import VideoSlash from './VideoSlash';
import VolumeHigh from './VolumeHigh';
import VolumeSlash from './VolumeSlash';
import Whatsapp from './Whatsapp';
import XTwitter from './XTwitter';
import Xmark from './Xmark';
import Youtube from './Youtube';

interface CustomSvgProps extends SvgProps {
  innerColor?: string;
}

type IconComponent<Props = CustomSvgProps> = React.FC<Props>;

type IconMap = { [key in IconsName]: IconComponent };

export const Icons: IconMap = {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowRotateLeft,
  ArrowRotateRight,
  ArrowUp,
  AudioLibrary,
  Back10Secs,
  Band,
  Bell,
  Bluesky,
  Bookmark,
  Bracket,
  ChevronDown,
  ChevronLeft,
  CircleStar,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleCheck,
  CircleExclamation,
  CircleMinus,
  CirclePlay,
  CirclePlus,
  CircleQuestion,
  CircleXmark,
  ClapperboardPlay,
  ClockRotateLeft,
  DeleteLeft,
  DownLeftAndUpRightToCenter,
  Envelope,
  Facebook,
  FaceFrown,
  FaceGrinWide,
  FaceSmile,
  Foward10Secs,
  Gear,
  Ghost,
  HexagonalExclamation,
  HouseWindow,
  Instagram,
  Lock,
  MagnifyinGlass,
  Minus,
  Number01,
  Number02,
  Number03,
  Number04,
  Number05,
  Number06,
  Number07,
  Number08,
  Number09,
  Number10,
  Play,
  PlayerLibrary,
  Plus,
  Popcorn,
  Radio,
  Screencast,
  ShareNodes,
  SolidBackwardStep,
  SolidBookmark,
  SolidCheck,
  SolidCircle,
  SolidFowardStep,
  SolidPause,
  SolidPauseCircular,
  SolidPlay,
  SolidPlayCircular,
  SolidUser,
  SquareCheck,
  SquareEllipsis,
  SquareMinus,
  SquareMusic,
  SquarePlus,
  SquareXmark,
  Streaming,
  Subtitles,
  Tiktok,
  Trash,
  TriangleExclamation,
  TurnBack,
  Tv,
  Twitter,
  TwoSliders,
  UpRightAndDownLeftFromCenter,
  Video,
  VideoSlash,
  VolumeHigh,
  VolumeSlash,
  Whatsapp,
  Xmark,
  XTwitter,
  Youtube,
  BandMore,
  CastClosedCaption,
  CastPauseSolid,
  CastXMarkSolid,
  Notify,
  Expand,
};

export const getIconByName = (name: IconsName) => {
  return Icons[name] || null;
};
